// Cloudinary Service
import { CloudinaryService } from "./cloudinary-service/cloudinaryService";
import { IApiConfiguration } from "./config/IAPIConfiguration";

const cloudinaryConfig: IApiConfiguration = {
    baseURL: "https://api.cloudinary.com/"
}
export const cloudinaryService = new CloudinaryService(cloudinaryConfig)